import React from "react";
import { FaInfoCircle } from "react-icons/fa"; // Ícone de informação


const DataCard = ({ title, value, tooltipText }) => {
  // Formata valores de moeda e porcentagem
  const formattedValue =
    title.startsWith("$") && typeof value === "number"
      ? new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value)
      : title.startsWith("%") && typeof value === "number"
      ? `${value * 100}%`
      : value;

  return (
    <div className="card">
      <div className="card_col">
        <h2>
          <b>{title}</b>
          {/* Ícone de informação com tooltip */}
          {tooltipText && (
            <span className="tooltip-container">
              <FaInfoCircle className="info-icon" />
              <span className="tooltip-text">{tooltipText}</span>
            </span>
          )}
        </h2>
        <p>{formattedValue}</p>
      </div>
    </div>
  );
};

export default DataCard;
